/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_Load_FailedInputs */

const vi_shop_contact_load_failed = /** @type {(inputs: Shop_Contact_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được thông tin liên hệ.`)
};

/**

* @param {Shop_Contact_Load_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_load_failed = /** @type {((inputs?: Shop_Contact_Load_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_Load_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_load_failed(inputs)
});